module.exports = __webpack_public_path__ + "img/REPORTING.34780750.svg";